import {APP_ID, Component, HostListener, Inject, PLATFORM_ID, ViewEncapsulation} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class AppComponent {
    title = 'koenigalexander';
    isShow: boolean;

    constructor(
        @Inject(PLATFORM_ID) private platformId: Object,
        @Inject(APP_ID) private appId: string
    ) {
    }

    topPosToStartShowing = 100;

    @HostListener('window:scroll')
    checkScroll() {

        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
        const body = document.body;
        //console.log('[scroll]', scrollPosition);
        if (scrollPosition >= this.topPosToStartShowing) {
            body.classList.add('scroll-down');
        } else {
            body.classList.remove('scroll-down');
        }

    }

    onActivate(event: any) {
        if (isPlatformBrowser(this.platformId)) {
            const scrollToTop = window.setInterval(() => {
                const pos = window.pageYOffset;
                if (pos > 0) {
                    window.scrollTo(0, pos - 50); // how far to scroll on each step
                } else {
                    window.clearInterval(scrollToTop);
                }
            }, 16);
        }
    }

}
